<template>
  <label :class="['checkboxStyle', { 'cursor-pointer': !disable }]">
    <input
      :id="checkboxId"
      :disabled="disable"
      :name="name"
      type="checkbox"
      :checked="isChecked"
      :value="value"
      @change="handleChange"
    >
    <span :class="['checkmark', { 'disable': disable }]" />
    <label
      :for="checkboxId"
      :class="['textChecked mb-0', { 'cursor-pointer': !disable, 'disable': disable }]"
    >
      {{ label }}
    </label>
  </label>
</template>

<script>
import { defineComponent, computed } from 'vue';
import "@/assets/css/components/base/checkbox.css";

export default defineComponent({
  name: "Checkbox",
  
  props: {
    value: { 
      type: [String, Number],
      default: undefined
    },
    name: {
      type: String,
      default: null,
    },
    disable: { 
      type: Boolean, 
      default: false 
    },
    modelValue: { 
      default: "",
      type: [Number, String, Boolean, Array] 
    },
    label: { 
      type: String, 
      required: true 
    },
    checkboxId: {
      type: String,
      required: true
    },
    trueValue: { 
      type: [String, Number, Boolean],
      default: true
    },
    falseValue: { 
      type: [String, Number, Boolean],
      default: false
    },
  },

  emits: ['update:modelValue', 'change'],

  setup(props, { emit }) {
    const isChecked = computed(() => {
      // اگر modelValue آرایه است (برای گروه checkbox ها)
      if (Array.isArray(props.modelValue)) {
        return props.modelValue.includes(props.value);
      }
      
      // اگر trueValue و falseValue تعریف شده‌اند
      if (props.trueValue !== undefined || props.falseValue !== undefined) {
        return props.modelValue === props.trueValue;
      }
      
      // حالت عادی boolean
      return !!props.modelValue;
    });

    const handleChange = (event) => {
      const checked = event.target.checked;
      
      if (Array.isArray(props.modelValue)) {
        // حالت گروه checkbox ها
        const newValue = checked
          ? [...props.modelValue, props.value]
          : props.modelValue.filter(item => item !== props.value);
        
        emit("update:modelValue", newValue);
        emit("change", newValue);
      } else if (props.trueValue !== undefined || props.falseValue !== undefined) {
        // حالت true-value/false-value
        const newValue = checked ? props.trueValue : props.falseValue;
        emit("update:modelValue", newValue);
        emit("change", newValue);
      } else {
        // حالت عادی boolean
        emit("update:modelValue", checked);
        emit("change", checked);
      }
    };

    return {
      isChecked,
      handleChange
    };
  }
});
</script>